import "core-js/stable";
import "regenerator-runtime/runtime";
import React from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "styled-components";
import { HelixThemeProvider } from "@helix/theming";
import theme from "../theme";
import Login from "../components/session/Login";
import ForgotPassword from "../components/session/ForgotPassword";
import "@helix/styles/dist/helix.css";

const components = {
  Login,
  ForgotPassword
};

function load() {
  document.querySelectorAll("[data-react-element]").forEach((element) => {
    const name = element.dataset.reactElement;
    const Component = components[name];

    if (!Component) return;

    const props = JSON.parse(element.dataset.reactElementProps || "{}");

    createRoot(element).render(
      <HelixThemeProvider>
        <ThemeProvider theme={theme}>
          <Component {...props} />
        </ThemeProvider>
      </HelixThemeProvider>
    );
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", load);
} else {
  load();
}
